import React from 'react';
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

export class XeroOnboarding extends React.Component {

  constructor(props)  {
      super(props);
  }

  componentWillMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (!code) {
      this.props.history.push("/settings/xero")
    }
    else {
      this.getToken(code);
    }
  }

  state = {
    statusView: '',
    importDone: false,
    settings: {},
    refreshToken: ''
  }

  getToken = async (code) => {
    var decodeCode = decodeURI(code);
    let requestParams = {
      'code': decodeCode
    }
    axios.post('/xero/auth/token', requestParams)
        .then(data => {
            this.setState({refreshToken: data.token})
            this.fetchSupplierData();
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to exchange code for token')
        })
  }

  fetchSupplierData = async () => {
    axios.get('/user')
        .then(data => {
          var settings = JSON.parse(data[0].settings)
          this.setState({
            settings: settings,
          });
          // Save token
          this.updateSettings()
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to fetch user data')
        })
  }

  updateSettings = async () => {
    let settings = this.state.settings
    let integration = {}
    integration.type = 'xero'
    integration.enabled = true
    integration.refreshToken = this.state.refreshToken
    settings.integration = integration
    let requestParams = {
      'settings': settings
    }
    axios.post('/user/update/settings', requestParams)
        .then(data => {
          this.setState({
            statusView: 'Import',
          });
          this.props.refreshSettings();
        })
        .catch (err => {
          console.error(err); 
          Rollbar.error(err)
          toast.error("Error: Could not save settings!");
        })
  }

  importData = async () => {
    toast.warning('Syncing Data...please wait', {autoClose: false})
    axios.get('/xero/import')
        .then(data => {
          this.setState({
            importDone: true
          });
          toast.dismiss()
          toast.success("Xero Data Successfully Imported!")
        })
        .catch (err => {
          toast.dismiss()
          console.error(err);
          Rollbar.error(err)
          toast.error("Error: Could not import data!");
        })
  }

    render() {
        return (
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center onboarding-logo-section">
                <h4>Setup Xero Integration</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.state.statusView === 'Import' ? (
                <div className="modal-dialog allow-click">
                  <div className="modal-content">
                    <div className="modal-header text-center">
                      <h4 className="modal-title ">Import Xero Data</h4>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        <label>Import Products</label>
                        <div>
                          <button type="button" className="btn btn-warning" disabled={this.state.importDone} onClick={() => this.importData()}>Start</button>
                        </div>
                        <small className="form-text text-muted">
                          This will import all active and inventoried products. Customers can be selected and imported individually on the Customers page after this.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="row pad-top">
                    <div className="col-md-12 text-center"><button type="button" className={this.state.importDone ? "btn btn-primary" : "btn btn-primary disabled"} onClick={() => this.props.history.push("/settings/xero")}>Finish</button></div>
                  </div>
                </div>) : null }
              </div>
            </div>
          </div>
        );
    }
}
